import React from 'react'

const ColorMapping = () => {
  return (
    <div>
      
    </div>
  )
}

export default ColorMapping
